// extracted by mini-css-extract-plugin
export default {"container":"CompetitorPriceCell_container__2izSV"};